import { module } from 'modujs';
import {TweenMax, Power3} from "gsap";
import Emitter from "tiny-emitter/instance";

export default class extends module {
    constructor(m) {
        super(m);
        this.isAnimating = false;
        this.isExpanded = false;
    }

    init(){
        this.initEffect();
    }

    initEffect(){
        this.back = this.$( 'back' )[0]
        if( ! this.back ) return;
        this.logo = this.$( 'logo' )[0];
        this.realBack = this.$( 'real-back' )[0];
        this.onResize();
        this.onResizeBind = this.onResize.bind( this );
        window.addEventListener( 'resize',  this.onResizeBind );

    }


    expandBackground(){
        if( window.innerWidth < 1280 ) return;
        if( this.isExpanded ){
            Emitter.emit('expandBackground', false );
            return;
        }
        if ( this.twBack ) this.twBack.kill();
        if ( this.twLogo ) this.twLogo.kill();
        this.isAnimating = true;
        this.twBack = TweenMax.to( this.back, { x : -this.backOffset, duration : 0.7, ease : Power3.easeOut, onComplete : () => {
            this.isAnimating = false;
            TweenMax.set( this.back, { opacity : 0 } );
            TweenMax.set( this.realBack, { opacity : 1 } );
            Emitter.emit('expandBackground', false );
            this.isExpanded = true;
        } } );
        this.twLogo = TweenMax.to( this.logo, { opacity : 1 } );
    }

    collapseBackground(){
        if( window.innerWidth < 1280 ) return;
        if( ! this.isExpanded || this.modules.Scroll.main.lenis.targetScroll > 10){
            Emitter.emit('collapseBackground', false );
            return;
        }
        if ( this.twBack ) this.twBack.kill();
        if ( this.twLogo ) this.twLogo.kill();
        this.isAnimating = true;

        TweenMax.set( this.back, { opacity : 1 } );
        TweenMax.set( this.realBack, { opacity : 0 } );

        this.twBack = TweenMax.to( this.back, { x : 0, duration : 0.7, ease : Power3.easeOut, onComplete : () => {
            this.isAnimating = false;
            Emitter.emit('collapseBackground', false );
            this.isExpanded = false;
        } } );
        this.twLogo = TweenMax.to( this.logo, { opacity : 0 } );
    }

    navigateIn(){
        [...this.$( 'menu' )[0].querySelectorAll('a')].forEach(a => {
            a.parentNode.classList.toggle( 'is-active', a.href === location.href );
        } );
    }

    navigateOut(){

    }


    onResize(){
        this.backOffset = this.back.parentNode.getBoundingClientRect().left;
    }

    destroy(){
        if( this.onResizeBind ){
            window.removeEventListener( 'resize',  this.onResizeBind );
        }
    }

}
